import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-changed-data-error-dialog',
  templateUrl: './changed-data-error-dialog.component.html',
  styleUrls: ['./changed-data-error-dialog.component.scss', '../../../../../../styles/global/_dialog-styles.scss']
})
export class ChangedDataErrorDialogComponent {

  constructor(public dialogRef: MatDialogRef<ChangedDataErrorDialogComponent>, @Inject(MAT_DIALOG_DATA) public errorMessage: string) {
  }

}
